<template>
  <v-flex id="aoi-page">
  <div id="active-page" :class="{'page-fade': !mountedPage}"></div>
    <modal-export @close-modal="modalAOI = false" :modalAOI="modalAOI" :images="allImages"></modal-export>
    <div v-if="currentImg !== undefined">
      <div class="contain-title">
        <v-icon @click="nextImg('prev')">chevron_left</v-icon>
        <p class="title font-weight-light">{{$t('titles.aoiSelection')}}</p>
        <v-icon @click="nextImg('next')">chevron_right</v-icon>
      </div>
      <div class="d-flex" id="center-page">
        <div class="col-md-2 sidebar-left">
          <div v-for="(image,index) in allImages" :key="index">
            <v-flex row no-gutters align-center mx-0>
              <button @click="() => clickPreviewImg(image)" class="col-md-10 btn-preview-img" :class="{'opacity-0': !currentImgLoaded}">
                <div class="contain-img" :class="{'selected': image.uuid === currentImg.uuid}">
                  <img :id="`img-${index}`" :src="image.file_url" :title="image.name">
                </div>
              </button>
              <v-checkbox
                :class="{'opacity-0': !currentImgLoaded}"
                @click.stop="() => controlCheckImg(image)"
                class="col-md-2 ml-auto"
                color="warning"
                v-model="image.checked"
              ></v-checkbox>
            </v-flex>
          </div>
        </div>
        <div class="col-md-8">
          <div v-for="(image, index) in this.allImages" :key="index">
            <div v-if="currentImg.uuid === image.uuid" v-show="currentImgLoaded" @click="newCanvas" id="canvas-content">
              <img @load="loaded()" :src="currentImg.file_url" alt="">
              <transition name="fade">
                <div class="load-img" v-if="imgChanging"></div>
              </transition>
            </div>
          </div>
          <div v-show="!currentImgLoaded" class="loading">
            <v-icon>mdi-loading mdi-spin</v-icon>
          </div>
        </div>
        <v-flex col-md-2 class="py-3">
          <div id="sidebar-right"  style="background-color:#272625" class="h-100 p-3">
          <v-flex class="text-center col-md-12">
            <p
              class="title font-weight-light text-center"
              style="border-bottom: 0.5px solid;padding: 6px;"
            >{{$t('titles.layerArea')}}</p>
          </v-flex>
          <div role="group">
            <v-flex row m-0>
              <div class="input-group py-2">
                <div v-for="canva in currentImg.canvasList" :key="canva.id" class="input-group-append w-100 pb-2">
                    <button @click="() => selectCanvas(canva)" class="btn btn-outline-warning aoi-letter-btn" :class="{'bg-warning': canva.selected,'not-valid': !canva.valided}">{{canva.id}}
                    </button>
                    <v-text-field
                      required
                      color="warning"
                      v-model="canva.label"
                    >
                    </v-text-field>
                    <button
                      class="btn btn-outline-danger ml-auto"
                      type="button"
                      @click="() => deleteCanvas(canva)"
                    >
                      <v-icon style="font-size:16px">delete</v-icon>
                    </button>
                  </div>
  
              </div>
            </v-flex>
          </div>
          </div>
        </v-flex>
      </div>
      <v-flex row id="bottom-aoi-interface">
        <v-flex p-3 col-md-4>
          <p class="title tools font-weight-light">{{$t('titles.tools')}}</p>
          <v-btn-toggle v-model="canvasType" id="aoi-btns-keep-svg" >
            <v-btn value="rectangle">
              <rectangle-vue/>
            </v-btn>
            <v-btn value="circle">
              <circle-vue/>
            </v-btn>
            <v-btn value="polygon">
              <lines-vue/>
            </v-btn>
          </v-btn-toggle>
        </v-flex>

        <v-flex col-md-4 class="input-name">
          <v-text-field @click="errorName = false"
              :error="errorName"
              v-model="currentImg.aoiName"
              :label="$t('placeholders.aoiName')"
              required
              color="warning"
              :disabled="drawing"
            ></v-text-field>
        </v-flex>
        <v-flex col-md-3 offset-md1 class="contain-btn-analyze">
        <div class="double-buttons">
          <a @click="$router.go(-1)">
            <itt-arrow-btn :text="$t('buttons.cancel')" direction="left" />
          </a>
          <button @click="previewAnalyzes">
            <!-- <designed-button name="ANALYZE" translate="translate(34.29 63.14)" class="btn-finish"></designed-button> -->
            <itt-arrow-btn :text="$t('buttons.analyze')" direction="right"/>
          </button>
        </div>
          <!-- <div style="position:relative;margin-left:4rem"> -->

          <!-- </div> -->
        </v-flex>
      </v-flex>
    </div>
    <p v-else class="text-center">{{$t('titles.noImgSelect')}}</p>
  </v-flex>
</template>

<script>


// import designedButton from "../../components/icons/designed-button.vue";
import linesVue from "../../components/icons/tools/lines.vue";
import circleVue from "../../components/icons/tools/circle.vue";
import rectangleVue from "../../components/icons/tools/rectangle.vue";
import Canvas from "./select-tools/index.js";
import ModalExport from "@/components/modals-form/modal-exportAOI";
import ittArrowBtn from "@/components/icons/arrow-btn";
export default {
  components: {
    // designedButton,
    linesVue,
    circleVue,
    rectangleVue,
    ModalExport,
    ittArrowBtn
  },
  mounted() {
    this.initImgs();
    setTimeout(() => this.mountedPage = true, 100);
  },
  data() {
    return {
      currentImg: "",
      currentImgLoaded: false,
      allImages: [],
      errorName: false,
      canvasType: null,
      modalAOI: false,
      imgChanging: true,
      mountedPage: false
    }
  },
  methods: {
    async getAllImages() {
      let allImgSelected = this.$store.getters["image/getMultiSelectImg"];
      let allImagesPreview = allImgSelected.map(
        async (uuid) => await this.$store.dispatch("image/getImg", uuid)
      );
      return await Promise.all(allImagesPreview);
    },
    async initImgs() {
      this.allImages = await this.getAllImages();
      this.allImages.forEach(img => {
        this.$set(img, 'checked', false);
        this.$set(img, 'canvasList', []);
        this.$set(img, 'aoiName', '');
        img.canvasCount = 0;
      });
      this.currentImg = this.allImages[0];
    },
    loaded() {
      this.imgChanging = false;
      this.currentImgLoaded = true;
      this.currentImg.canvasList.forEach((canva) => {
        canva.initCanvas();
        canva.draw()
      });
    },
    createCanvaId () {
      let code = 97 + this.currentImg.canvasCount;
      let id;
      if (code <= 122)
        id = String.fromCharCode(code).toUpperCase();
      else {
        let code1 = Math.floor((code - 123) / 26) + 97;
        let code2 = (code - 123) % 26 + 97;
        id = String.fromCharCode(code1) + String.fromCharCode(code2);
        id = id.toUpperCase();
      }
      return id;
    },
    // Crée un nouveau canvas qui contient une forme de type "rectangle", "circle" ou "line".
    newCanvas() {
      if (!this.canvasType) return;
      if (this.drawing) return;
      let img = document.querySelector("#canvas-content img");
      let imgStyle = getComputedStyle(img);
      let x = parseInt(imgStyle["width"]);
      let y = parseInt(imgStyle["height"]);
      let canva = new Canvas[this.canvasType](x, y, this.createCanvaId());
      let number = ++this.currentImg.canvasCount;
      this.$set(canva, 'valided', false);
      this.$set(canva, 'label', 'AOI ' + number);
      this.$set(canva, 'selected', false);
      this.currentImg.canvasList.push(canva);
      this.allImages[this.allImages.indexOf(this.currentImg)].checked = true;
    },
    deleteCanvas(canvasObj) {
      if (canvasObj.selected === true) 
        this.selectCanvas({selected: true});
      this.removeAllHtmlCanvas();
      let index = this.currentImg.canvasList.indexOf(canvasObj);
      let canList = this.currentImg.canvasList;
      canList.splice(index, 1);
      this.currentImg.canvasCount = 0;
      canList.forEach((canvas) => {
        canvas.id = this.createCanvaId();
        this.currentImg.canvasCount ++;
        if (canvas.label.includes('AOI '))
          canvas.label = 'AOI ' + this.currentImg.canvasCount;
      });
      this.loaded();
      if (this.currentImg.canvasList.length === 0) {
        this.errorName = false;
        this.currentImg.checked = false;
      }
    },
    removeAllHtmlCanvas() {
      this.currentImg.canvasList.forEach(canvas => {
        let canvasToDelete = document.getElementById("canvas-" + canvas.id);
        let startPointToDelete = document.getElementById('start-point-' + canvas.id);
        let parent = canvasToDelete.parentElement;
        if (startPointToDelete) 
          parent.removeChild(startPointToDelete);
        parent.removeChild(canvasToDelete);
      });
    },
    clickPreviewImg(image) {
      if (this.drawing) return;
      if (this.currentImg.aoiName.trim().length === 0 && this.currentImg.canvasList.length !== 0) {
        this.$store.commit('dialogModal/toggleNotif', [this.$t('titles.aoiNameRequired'), this.$t('texts.aoiNameRequired')]);
          return this.errorName = true;
        }
      this.imgChanging = true;
      this.currentImg = image;
    },
    nextImg(way) {
      if (this.drawing) return;
      if (this.currentImg.aoiName.trim().length === 0 && this.currentImg.canvasList.length !== 0) {
          this.$store.commit('dialogModal/toggleNotif', [this.$t('titles.aoiNameRequired'), this.$t('texts.aoiNameRequired')]);
          return this.errorName = true;
        }
      let index = this.allImages.indexOf(this.currentImg);
      let sidebar = document.querySelector('#center-page>.sidebar-left')
      let scrollPos = 0;
      if (way === 'next' && ++index <= this.allImages.length - 1) {
        this.currentImg = this.allImages[index];
        this.imgChanging = true;
        for (let i = 0; i < index; i++) {
          let imgRend = document.getElementById(`img-${i}`).parentElement.parentElement.parentElement;
          let imgHeight = parseInt(getComputedStyle(imgRend).height);
          scrollPos += imgHeight;
        }
        sidebar.scrollTo(0, scrollPos);
      }
      else if (way === 'prev' && --index >= 0) {
        this.currentImg = this.allImages[index];
        this.imgChanging = true;
        for (let i = 0; i < index; i++) {
          let imgRend = document.getElementById(`img-${i}`).parentElement.parentElement.parentElement;
          let imgHeight = parseInt(getComputedStyle(imgRend).height);
          scrollPos += imgHeight;
        }
        sidebar.scrollTo(0, scrollPos);
      }
    },
    controlCheckImg(image) {
      if (image.canvasList.length !== 0)
        image.checked = !image.checked 
      else
        image.checked = false;
    },
    previewAnalyzes() {
      if (this.drawing) return;
      // vérification aoiName pour le dernier AOI manipulé
      if (this.currentImg.aoiName.trim().length === 0 
        && this.currentImg.canvasList.length !== 0) {
          this.$store.commit('dialogModal/toggleNotif', [this.$t('titles.aoiNameRequired'), this.$t('texts.aoiNameRequired')]);
        return this.errorName = true;
      }
      let imgSelected = false;
      // check if there is minimum 1 selected image
      this.allImages.forEach(image => {
        if (image.checked === true) {
          imgSelected = true;
          return;
        }
      })
      if (imgSelected === true)
        this.modalAOI = true;
      else 
        this.$store.commit('dialogModal/toggleNotif', [this.$t('titles.noImgSelect'), this.$t('texts.defineAreasRequired')])
    },
    async selectCanvas(canvaSelected) {
      if (this.currentImg.canvasList.length === 0) return;
      if (this.drawing) return;
      canvaSelected.selected = !canvaSelected.selected;
      let allCanvas = document.querySelectorAll("#canvas-content canvas");
      switch (canvaSelected.selected){
        case true:
          this.canvasType = null;
          canvaSelected.initMove();
          allCanvas.forEach((domCanvas)=> {
            if (domCanvas.id === 'canvas-' + canvaSelected.id) {
              domCanvas.style.opacity = 1;
              domCanvas.style.zIndex = 100;
            } else {
              domCanvas.style.opacity = 0.4;
              domCanvas.style.zIndex = 0;
            }
          });
          break;
        case false:
          canvaSelected.terMove !== undefined && canvaSelected.terMove(canvaSelected.canvas);
          allCanvas.forEach(domCanvas => {
            domCanvas.style.opacity = 1;
            domCanvas.style.zIndex = 0;
          })
      }
      this.currentImg.canvasList.forEach((canvas) => {
        if (canvas.id !== canvaSelected.id) {
          canvas.selected = false;
          canvaSelected.terMove !== undefined && canvas.terMove(canvas.canvas);
        }
      });
    },
  },
  computed: {
    drawing() {
      let canList = this.currentImg.canvasList;
      if (!canList || canList.length === 0) return false;
      if (canList[canList.length - 1].valided === false) return true;
      return false;
    }
  },
  watch: {
    canvasType(value) {
      if (this.drawing) return;
      if (value !== null && this.currentImg.canvasList[0]) {
        let terMove = this.currentImg.canvasList[0].terMove
        this.selectCanvas({selected: true, canvasList: [''], terMove});
      }
    }
  },
}
</script>

<style>
  @import url('./style/canva.css');
  @import url('./style/page.css');
  .load-img {
    position: absolute;
    top: -10px;
    bottom: -10px;
    left: -10px;
    right: -10px;
    background-color: #171717;
  }
  .opacity-0 {
    opacity: 0;
    height: 0;
  }
  .btn-preview-img , .btn-preview-img + .v-input{
    transition: opacity ease .5s .5s
  }
  .contain-btn-analyze {
    display: flex;
    justify-content: center;
  }
  .contain-btn-analyze button {
    display: flex;
  }
  .contain-title .title {
    text-transform: uppercase;
  }
  #sidebar-right .title {
    text-transform: uppercase;
  }
  #bottom-aoi-interface {
    text-transform: uppercase;
  }
  #aoi-page .double-buttons {
    align-self: center;
    bottom: unset;
  }
</style>